/**
 * Assinatura (plano, épico 9 e seção 25).
 * - 14 dias grátis, sem cartão.
 * - Bloqueio suave ao vencer: ver a agenda continua; marcar novo pede assinatura.
 */
import type { Professional } from '../schemas/entities';
import { DAY, toMs } from './time';

export const TRIAL_DAYS = 14;
/** Dias de tolerância depois de uma cobrança falhar. */
export const PAST_DUE_GRACE_DAYS = 5;

export const PLAN_INFO = {
  essencial: { name: 'Essencial', priceCents: 2490, description: 'Para manicure e pedicure: agenda, link do cliente, caixa e funciona sem internet.' },
  estetica: { name: 'Estética', priceCents: 4490, description: 'Tudo do Essencial e mais pacotes de sessões.' },
} as const;

export type AccessState =
  | { kind: 'trial'; daysLeft: number; canCreate: true }
  | { kind: 'active'; canCreate: true }
  | { kind: 'past_due'; daysLeft: number; canCreate: boolean }
  | { kind: 'expired'; canCreate: false };

export function accessState(
  prof: Pick<Professional, 'subscription_status' | 'trial_ends_at' | 'current_period_end'>,
  now: number | string = Date.now(),
): AccessState {
  const t = toMs(now);
  switch (prof.subscription_status) {
    case 'active':
      return { kind: 'active', canCreate: true };
    case 'trialing': {
      const end = prof.trial_ends_at ? toMs(prof.trial_ends_at) : t + TRIAL_DAYS * DAY;
      const daysLeft = Math.ceil((end - t) / DAY);
      if (daysLeft > 0) return { kind: 'trial', daysLeft, canCreate: true };
      return { kind: 'expired', canCreate: false };
    }
    case 'past_due': {
      const end = prof.current_period_end ? toMs(prof.current_period_end) + PAST_DUE_GRACE_DAYS * DAY : t;
      const daysLeft = Math.max(0, Math.ceil((end - t) / DAY));
      return { kind: 'past_due', daysLeft, canCreate: daysLeft > 0 };
    }
    default:
      return { kind: 'expired', canCreate: false };
  }
}
